// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const cnqa1 = {
  name: 'cn.qa1',
  production: false,
  domain: 'https://qa1.thermofisher.cn/',
  services: {
    cloudReferrer: "https://test.apps.thermofisher.com/apps/dashboard/#/",
    cdcam: {
      reset_password: {
        request_email: 'https://qa1.thermofisher.cn/cdcam/identity/reset-password/email',
        request: 'https://qa1.thermofisher.cn/cdcam/identity/reset-password/'
      },
      recover_username: 'https://qa1.thermofisher.cn/cdcam/accounts/username/recovery',
      identity: {
        login: 'https://qa1.thermofisher.cn/cdcam/identity/registration/redirect/login',
        registration: 'https://qa1.thermofisher.cn/identity/account/registration',
        federation: {
          enabled: true,
          find_federated: '/api-gateway/identity-authorization/identity/fed/findfederateduser'
        },
        liteRegCheck: "/identity/api/cip/v1/literegistered/",
        rpUrls:"/api-gateway/identity-authorization/identity/auth-services/rp/urls/"
        }
      },weChat:{
        loginID: "/api-gateway/identity-wechat/identity/wechat/auth/loginId",
        authBind: "/api-gateway/identity-wechat/identity/wechat/auth/bind",
      }
  },
  adobe: {
    digitalData: '/etc/designs/lifetech/clientlibs/digitaldata.min.js',
    enabled: true,
    launch: 'ENe956028acf6f4129a803968d774515c2-development'
  },
  pages: {
    loginError: "/account-center/loginError.html?source=gigyajs-proxy",
    contact_us: '/us/en/home/technical-resources/contact-us.html',
    privacy_policy: '/cn/zh/home/global/privacy-policy.html',
    policy_freight: '/cn/zh/home/global/online-pricing-policy.html',
    terms_condition: '/cn/zh/home/global/terms-and-conditions.html',
    china: {
      contact_us_cn: '/cn/zh/home/hotline-guideline.html',
      business_check: 'https://218.242.124.22:8082/businessCheck/verifKey.do?showType=extShow&serial=9031000020171215105412000002252469-SAIC_SHOW_310000-4028e4cb6493ac2c0164c34158830f04018&signData=MEUCIGaAKW51heNd3cUsvTfF7YfkQoSdAyn4cx1XhwWh1t7BAiEAj22lrLm+yIbfvVqeOKnPa+Pz7/e6ouAI9EC1cJRPHRs=',
      icp_registration_number: 'https://beian.miit.gov.cn/',
      license: '/cn/zh/home/global/licenses-cn.html'
    }
  },
  resources: {
    reCaptchaV3: {
      siteKey: '6Le8KYIjAAAAAJemaY7l9p507p_BKFVnKSZksDz6'
    },
    reCaptchaV2: {
      siteKey: '6LehLoIjAAAAADom4YrEx81y4jEfkBpbqQC5KcmA'
    }
  },
  shared_static: {
    global: '/shared-static/scripts/global-variables.js'
  }
};
